export const CODE_POSTAL_MAYOTTE = '976' as const
export const CODES_POSTAUX_DROM = ['971', '972', '973', '974'] as const
export const CODES_POSTAUX_UNIQUE = ['97133', '97150', CODE_POSTAL_MAYOTTE, '975'] as const

export const SMIC_HOR_BRUTE = parseFloat(import.meta.env.VITE_DEMANDE_SMIC_HOR_BRUTE)
export const SMIC_HOR_BRUTE_MAYOTTE = parseFloat(import.meta.env.VITE_DEMANDE_SMIC_HOR_BRUTE_MAYOTTE)
